import api from '@pray/shared/utils/api';

import type {
  RecurringPushCampaignListItem,
  RecurringPushCampaignListResponse,
  RecurringPushCampaignStatus,
  RecurringPushCampaignStatusCounts,
} from './types';

// Full envelope from `sendPaginatedListResponseWithTotal`. The outer `data`
// layer is added by the api wrapper; this `data` field holds the rows.
type ListEnvelope = {
  responded_at: string;
  object: 'list';
  last_item_identifier: string | number | null;
  data_count: number;
  total: number;
  limit: number;
  offset: number;
  counts?: RecurringPushCampaignStatusCounts;
  data: RecurringPushCampaignListItem[];
};

export async function listRecurringPushCampaigns({
  artistId,
  offset,
  limit,
  status,
}: {
  artistId: string;
  offset?: number;
  limit?: number;
  status?: RecurringPushCampaignStatus;
}): Promise<RecurringPushCampaignListResponse> {
  if (!artistId) throw new Error('Artist ID is required');

  const params: Record<string, string | number> = {};
  if (offset !== undefined) params.offset = offset;
  if (limit !== undefined) params.limit = limit;
  if (status) params.status = status;

  const url = `/web/studio/artists/${artistId}/campaigns/recurring-push`;
  const response = await api.executeGetRequest<ListEnvelope>(url, params);
  const envelope = response.data;
  return {
    data: envelope.data,
    data_count: envelope.data_count,
    total: envelope.total,
    limit: envelope.limit,
    offset: envelope.offset,
    counts: envelope.counts,
  };
}
